import React, { useMemo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FaxIcon } from 'assets';
import { ControlTooltip } from 'components';

import styles from './ToggleFaxesButton.module.scss';

type ToggleFaxesButtonProps = {
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
  iconColor?: string;
  withTooltip?: boolean;
  withLabel?: boolean;
  onClick: () => void;
};

export function ToggleFaxesButton({
  disabled,
  className,
  iconClassName,
  iconColor,
  withTooltip,
  withLabel,
  onClick,
}: ToggleFaxesButtonProps) {
  const { t } = useTranslation('providerRoom');

  const tooltipMessage = useMemo(() => {
    let tooltip = '';

    if (withTooltip) {
      tooltip = t('faxes');
    }

    return tooltip;
  }, [withTooltip, t]);

  return (
    <ControlTooltip title={tooltipMessage} isDisabled={disabled}>
      <Box component='span' display='block' className={classnames(styles.deviceButton, className)}>
        <IconButton
          disabled={disabled}
          className={classnames(
            { [styles.deviceButton]: !withLabel, [styles.deviceButtonWithLabel]: withLabel },
            className,
          )}
          onClick={onClick}
        >
          <FaxIcon className={classnames(styles.icon, iconClassName)} sx={{ color: iconColor || '#fff' }} />
          {withLabel && (
            <Typography component='p' variant='body2' sx={{ color: 'var(--app-text-default)' }} ml='10px'>
              {t('faxes')}
            </Typography>
          )}
        </IconButton>
      </Box>
    </ControlTooltip>
  );
}
